export default "__VITE_ASSET__e4c7bc6b__"